// extracted by mini-css-extract-plugin
export default {"popup_window":"popup_window___q4LjT","abs_position":"abs_position___RhmQG"};